module.exports = "h5.description {\n  font-weight: 600;\n  font-size: 1.9em; }\n"